import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { routerAnimation } from '../shared/animations';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  animations: [routerAnimation],
})
export class AdminLayoutComponent implements AfterViewChecked {
  private _changeRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  public ngAfterViewChecked(): void {
    this._changeRef.detectChanges();
  }
}
